// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"326":"component---src-pages-error-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"326":"858bdb527aff2549d59a","678":"610d7eb6d3e446fa8cde"}[chunkId] + ".js";
};